/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 3/14/2022
 * Time: 2:47 PM
 * Project: w_crm
 */
import React from "react";
import "./style.css";

function LoadingSpinner({ fill = "full-screen", isLoading = true, text = null }) {
  let wrapperCss = "loading-spinner-component-loading-bg-holder";

  let outerCSS = "loading-spinner-component-loading-spinner-1";
  let innerCSS = "loading-spinner-2";

  if (fill === "full-screen") {
    wrapperCss = `${wrapperCss} loading-spinner-fill-screen`;
  } else if (fill === "mini") {
    wrapperCss = `${wrapperCss} loading-spinner-fill-parent mini`;
    innerCSS = `${innerCSS} mini`;
    outerCSS = `${outerCSS} mini`;
  } else {
    wrapperCss = `${wrapperCss} loading-spinner-fill-parent`;
  }
  return (
    <>
      {isLoading && (
        <div className={wrapperCss}>
          <div className="loading-content-wrapper">
            <div className={outerCSS}>
              <div className={innerCSS} />
            </div>
            {text && <p className={`loading-text ${fill === "mini" ? "mini" : ""}`}>{text}</p>}
          </div>
        </div>
      )}
    </>
  );
}

export default LoadingSpinner;
